import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GlobalConstants } from 'src/app/globalConstants';
import { User } from 'src/app/interfaces/User';
import { AccountService } from 'src/app/services/account.service';
import { AuthService } from 'src/app/services/auth.service';
import { CustomLoaderService } from 'src/app/services/custom-loader.service';
import { MainService } from 'src/app/services/main.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {


 currentUser: User = null;
 error = null;
 user:any
 currentYear = new Date().getFullYear();


  constructor(
    private loader: NgxUiLoaderService,
    private MainService: MainService,
    private snackbar: SnackbarService,
    private customLoaderService: CustomLoaderService,
  private AccountService: AccountService,
    private dialog: MatDialog,
    private AuthService: AuthService,
    private router: Router,
  

  ) { }
  ngOnInit(): void {
    this.getUser()
    this.AccountService.getSharedUser().subscribe((data) => {
      this.user = data;   
    });
   

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.scrollToTop();
      }
    });
  }

  
   getUser() {
  
    // start loading
    this.loader.start('10002');
  
    // send the request
    this.AccountService.getUserData().subscribe(res => {
      // stop loading
      this.loader.stop('10002');
  
      this.currentUser = <User> res['data']['user'];
      
      this.AccountService.setSharedUser(this.currentUser);
  
    }, (e) => {
      // stop loading — not logged in is fine
      this.loader.stop('10002');
      this.AccountService.setSharedUser(null);
      this.user = null;
    })
  }

  logout() {
    // start loading
    this.loader.start();
  
    this.AuthService.logout().subscribe(
      (res) => {
        // stop loading
        this.loader.stop();
  
        // go to login page
        this.router.navigate(['/auth']);
  
        window.location.href = '/';
      },
      (e) => {
        // stop loading
        this.loader.stop();
  
        // show the error
        this.error = this.snackbar.showError(e);
  
      })
  }
  openSignInDialog() {
    this.router.navigate(['/auth/signin']);
  }
  scrollToTop() {
    window.scrollTo(0, 0);
  }

  
}
